import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';
import NumberFormat from 'react-number-format';
import SelectAsync from 'react-select/async';

export default class Bill extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            buildingId: props.BuildingId,
            type: props.Type,
            caller: props.Caller,
            data: null,
            loading: true,
            units: [],
            gridVersion: this.uuidv4(),
            totalVersion: this.uuidv4(),
            divisionVersion: this.uuidv4()
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        var p1 = this.httpPost("api/v1/building/unit/list", {
            filters: {
                buildingId: this.state.buildingId
            }
        })
            .then(data => {
                if (data.status === 1) {
                    data.records.forEach(item => {
                        var label = "";
                        if (!this.isBlank(item.floor)) label += "طبقه " + item.floor;
                        if (!this.isBlank(item.unitNumber)) label += " واحد " + item.unitNumber;
                        if (!this.isBlank(item.customerName)) label += " مستاجر (" + item.customerName + ")";
                        if (!this.isBlank(item.ownerName)) label += " مالک (" + item.ownerName + ")";

                        var parkingCount = 0;
                        if (!this.isBlank(item.parking)) parkingCount++;
                        if (!this.isBlank(item.parking2)) parkingCount++;

                        this.state.units.push({
                            floor: item.floor,
                            value: item.id,
                            label: label,
                            numberPeople: item.numberPeople,
                            metrag: item.metrag,
                            parkingCount: parkingCount,
                            isBlankUnit: item.empty,
                            buildingUnitCategoryId: item.buildingUnitCategoryId,
                            shareOfTotal: item.shareOfTotal
                        });
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });

        var p2 = this.httpPost("api/v1/expensebill/get", {
            id: this.getCurrentFormId(),
            buildingId: this.state.buildingId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });

        Promise.all([p1, p2])
            .then(resualt => {
                if (this.state.data.record.id === this.getDefaultGuid())
                    this.setUnits();
                this.setState({
                    loading: false
                });
            })
    }
    setUnits() {
        var units = [];

        this.state.units.forEach(u => {
            var validToInput = true;
            if (this.state.data.record.wichUnit == 1) {
                if (u.isBlankUnit != false) validToInput = false;
            }
            if (this.state.data.record.wichUnit == 2) {
                if (u.isBlankUnit != true) validToInput = false;
            }
            if (this.state.data.record.buildingUnitCategoryId != this.getDefaultGuid() && this.state.data.record.buildingUnitCategoryId != u.buildingUnitCategoryId) {
                validToInput = false;
            }
            if (validToInput) {
                units.push({ price: 0, discount: 0, unitId: u.value });
            }
        });

        //if (this.state.data.record.wichUnit == 0) {
        //    this.state.units.forEach(u => {
        //        units.push({ price: 0, discount: 0, unitId: u.value });
        //    });
        //}
        //if (this.state.data.record.wichUnit == 1) {
        //    this.state.units.forEach(u => {
        //        if (u.isBlankUnit == false) units.push({ price: 0, discount: 0, unitId: u.value });
        //    });
        //}
        //if (this.state.data.record.wichUnit == 2) {
        //    this.state.units.forEach(u => {
        //        if (u.isBlankUnit == true) units.push({ price: 0, discount: 0, unitId: u.value });
        //    });
        //}
        //if (this.state.data.record.wichUnit == 3) {
        //    this.state.units.forEach(u => {
        //        units.push({ price: 0, discount: 0, unitId: u.value });
        //    });
        //}
        //if (this.state.data.record.wichUnit == 4) {
        //    this.state.units.forEach(u => {
        //        if (this.state.data.record.buildingUnitCategoryId == u.buildingUnitCategoryId) {
        //            units.push({ price: 0, discount: 0, unitId: u.value });
        //        }
        //    });
        //}
        this.state.data.record.units = units;
        this.unitPriceCalculate();
    }
    setUnitDiscount(unitId, discount) {
        this.state.data.record.units.forEach(u => {
            if (u.unitId == unitId) u.discount = discount;
        });
        this.unitPriceCalculate();
        this.setState({ totalVersion: this.uuidv4() });
    }
    unitPriceCalculate() {
        var numberPeople = 0;
        var metrag = 0;
        var shareOfTotal = 0;
        var parkingCount = 0;

        if (this.state.type === 1) {
            this.state.units.forEach(u => {
                numberPeople += u.numberPeople;
                metrag += u.metrag;
                parkingCount += u.parkingCount;
                shareOfTotal += u.shareOfTotal;
            });
            if (numberPeople == 0) numberPeople = 1;
            if (metrag == 0) metrag = 1;
            if (parkingCount == 0) parkingCount = 1;
            if (shareOfTotal == 0) shareOfTotal = 1;
        }

        if (this.state.type === 2) this.state.data.record.price = 0;

        this.state.data.record.units.forEach(unit => {

            if (this.state.type === 1) {
                if (this.state.data.record.divisionType === 0) {
                    unit.price = this.state.data.record.price;
                }
                if (this.state.data.record.divisionType === 1) {
                    var eachShare = (this.state.data.record.price / numberPeople);
                    unit.price = Math.round(eachShare * this.getUnitNumberPeople(unit.unitId));
                }
                if (this.state.data.record.divisionType === 2) {
                    var eachShare = (this.state.data.record.price / metrag);
                    unit.price = Math.round(eachShare * this.getUnitMetrag(unit.unitId));
                }
                if (this.state.data.record.divisionType === 3) {
                    var eachShare = (this.state.data.record.price / parkingCount);
                    unit.price = Math.round(eachShare * this.getUnitParkingCount(unit.unitId));
                }
                if (this.state.data.record.divisionType === 4) {
                    if (this.state.data.record.units.length > 0)
                        unit.price = Math.round(this.state.data.record.price / this.state.data.record.units.length);
                    else
                        unit.price = 0;
                }
                if (this.state.data.record.divisionType === 5) {
                    var eachShare = (this.state.data.record.price / shareOfTotal);
                    unit.price = Math.round(eachShare * this.getUnitShareOfTotal(unit.unitId));
                }
            }

            if (this.state.type === 2) {
                unit.price = 0;

                this.state.data.record.formulas.forEach(formula => {
                    if (formula.multiplierType === 0) {
                        unit.price += formula.price;
                    }
                    if (formula.multiplierType === 1) {
                        unit.price += Math.round(formula.price * this.getUnitNumberPeople(unit.unitId));
                    }
                    if (formula.multiplierType === 2) {
                        unit.price += Math.round(formula.price * this.getUnitMetrag(unit.unitId));
                    }
                    if (formula.multiplierType === 3) {
                        unit.price += Math.round(formula.price * this.getUnitParkingCount(unit.unitId));
                    }
                    if (formula.multiplierType === 4) {
                        var floor = this.getUnitFloor(unit.unitId);
                        if (!this.isBlank(floor)) {
                            unit.price += Math.round(formula.price * parseInt(floor));
                        }
                    }
                });

                this.state.data.record.price += (unit.price - unit.discount);
            }
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/expensebill/save", {
            id: this.state.id,
            type: this.state.type,
            formulas: this.state.data.record.formulas,
            dateStart: this.convertMomentToDb(this.state.data.record.dateStart),
            dateEnd: this.convertMomentToDb(this.state.data.record.dateEnd),
            price: this.state.data.record.price,
            buildingId: this.state.data.record.buildingId,
            expenseId: this.state.data.record.expenseId,
            attachment: this.state.data.record.attachment,
            billExpenseType: this.state.data.record.billExpenseType,
            divisionType: this.state.data.record.divisionType,
            wichPerson: this.state.data.record.wichPerson,
            wichUnit: this.state.data.record.wichUnit,
            units: this.state.data.record.units,
            buildingUnitCategoryId: this.state.data.record.buildingUnitCategoryId,
            followNumber: this.state.data.record.followNumber,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setType(e) {
        this.state.data.record.billExpenseType = e;
        this.setState({ data: this.state.data });
    }
    setWichUnit(e) {
        this.state.data.record.wichUnit = e;
        this.setUnits();
        this.setState({ gridVersion: this.uuidv4() });
    }
    setDivisionType(e) {
        this.state.data.record.divisionType = e;
        this.unitPriceCalculate();
        this.setState({ gridVersion: this.uuidv4() });
    }
    getUnitTitle(id) {
        var label = '';
        this.state.units.forEach(u => {
            if (u.value === id) label = u.label;
        });
        return label;
    }
    getUnitNumberPeople(id) {
        var numberPeople = 0;
        this.state.units.forEach(u => {
            if (u.value === id) numberPeople = u.numberPeople;
        });
        return numberPeople;
    }
    getUnitMetrag(id) {
        var metrag = 0;
        this.state.units.forEach(u => {
            if (u.value === id) metrag = u.metrag;
        });
        return metrag;
    }
    getUnitShareOfTotal(id) {
        var shareOfTotal = 0;
        this.state.units.forEach(u => {
            if (u.value === id) shareOfTotal = u.shareOfTotal;
        });
        return shareOfTotal;
    }
    getUnitParkingCount(id) {
        var parkingCount = 0;
        this.state.units.forEach(u => {
            if (u.value === id) parkingCount = u.parkingCount;
        });
        return parkingCount;
    }

    getUnitFloor(id) {
        var floor = '';
        this.state.units.forEach(u => {
            if (u.value === id) floor = u.floor;
        });
        return floor;
    }
    setPrice(e) {
        this.state.data.record.price = parseInt(e);
        this.unitPriceCalculate();
        this.setState({ gridVersion: this.uuidv4() });
    }
    setBuildingUnitCategory(e) {
        if (e == null) {
            this.state.data.record.buildingUnitCategoryId = this.getDefaultGuid();
            this.state.data.record.buildingUnitCategoryTitle = '';
        }
        else {
            this.state.data.record.buildingUnitCategoryId = e.value;
            this.state.data.record.buildingUnitCategoryTitle = e.label;
        }
        this.setUnits();
        this.setState({ gridVersion: this.uuidv4() });
    }

    setFormula(id, f, v) {
        this.state.data.record.formulas.forEach(child => {
            if (child.id === id) child[f] = v;
        });
        this.unitPriceCalculate();
        this.setState({ gridVersion: this.uuidv4() });
    }
    getBlankFormula() {
        return {
            id: this.uuidv4(),
            multiplierType: 0,
            price: 0
        };
    }
    addNewFormual() {
        this.state.data.record.formulas.push(this.getBlankFormula());
        this.unitPriceCalculate();
        this.setState({ gridVersion: this.uuidv4() });
    }
    removeFormula(id) {
        var t = [];
        this.state.data.record.formulas.forEach(child => {
            if (child.id !== id) t.push(child);
        });
        this.state.data.record.formulas = t;
        this.unitPriceCalculate();
        this.setState({ gridVersion: this.uuidv4() });
    }
    getPriceFromDocuments() {
        this.httpPost("api/v1/expensebill/getdoucmentsprice", {
            dateStart: this.convertMomentToDb(this.state.data.record.dateStart),
            dateEnd: this.convertMomentToDb(this.state.data.record.dateEnd),
            expenseId: this.state.data.record.expenseId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data.record.divisionType = data.divisionType;
                    this.state.data.record.price = data.price;
                    this.unitPriceCalculate();
                    this.setState({
                        divisionVersion: this.uuidv4(),
                        loading: false,
                        gridVersion: this.uuidv4()
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات صورتحساب" : "افزودن صورتحساب جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    {this.state.data.record.id === this.defaultGuid() && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="form-label">نوع</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.billExpenseType} onChange={e => this.setType(parseInt(e.target.value))} className='form-control'>
                                                <option value="1">هزینه ای</option>
                                                <option value="2">درآمدی</option>
                                            </select>
                                        </div>
                                    </div>}
                                    {this.state.data.record.billExpenseType === 1 && <div className="col-sm-8">
                                        <label className="form-label">دفتر هزینه</label>
                                        <div className="form-control-wrap">
                                            <SelectAsync
                                                defaultValue={this.state.data.record.expenseId != this.getDefaultGuid() ? [{ value: this.state.data.record.expenseId, label: this.state.data.record.expensesType }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب دفتر"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadExpensesOptions(inputValue, callback, 6)}
                                                onChange={e => this.state.data.record.expenseId = e.value}
                                            />
                                        </div>
                                    </div>}
                                    {this.state.data.record.billExpenseType === 2 && <div className="col-sm-8">
                                        <label className="form-label"> دفتر درآمد</label>
                                        <div className="form-control-wrap">
                                            <SelectAsync
                                                defaultValue={this.state.data.record.expenseId != this.getDefaultGuid() ? [{ value: this.state.data.record.expenseId, label: this.state.data.record.expensesType }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب دفتر"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadExpensesOptions(inputValue, callback, 5)}
                                                onChange={e => this.state.data.record.expenseId = e.value}
                                            />
                                        </div>
                                    </div>}
                                </div>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">از تاریخ<span className="red">*</span></label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.dateStart = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.dateStart)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">تا تاریخ<span className="red">*</span></label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.dateEnd = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.dateEnd)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">مبلغ</label>
                                            {this.state.type === 1 && this.state.data.record.billExpenseType === 1 && <a className="text-success hand" onClick={e => this.getPriceFromDocuments()}> جمع آوری اسناد قطعی هزینه</a>}
                                            <span className="red">*</span>
                                            {this.state.type === 1 && <NumberFormat value={this.state.data.record.price} onChange={e => this.setPrice(this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control' />}
                                            {this.state.type === 2 && <NumberFormat value={this.state.data.record.price} disabled={true} thousandSeparator={true} prefix={''} className='form-control' />}
                                        </div>
                                    </div>
                                    {this.state.type === 1 && <div className="col-sm-3" key={this.state.divisionVersion }>
                                        <div className="form-group">
                                            <label for="name" className="form-label">تقسیم بر اساس</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.divisionType} onChange={e => this.setDivisionType(parseInt(e.target.value))} className='form-control'>
                                                <option value="0">هر واحد به اندازه کل مبلغ</option>
                                                <option value="1">تعداد نفرات</option>
                                                <option value="2">متراژ</option>
                                                <option value="3">تعداد پارکینگ</option>
                                                <option value="4">مساوی بین واحدها</option>
                                                <option value="5">سهم واحد از کل ساختمان</option>
                                            </select>
                                        </div>
                                    </div>}
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="form-label">برای</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.wichPerson} onChange={e => this.state.data.record.wichPerson = (parseInt(e.target.value))} className='form-control'>
                                                <option value="0">مالک یا مستاجر</option>
                                                <option value="1">مالک</option>
                                                <option value="2">مستاجر</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="form-label">مشمول</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.wichUnit} onChange={e => this.setWichUnit(parseInt(e.target.value))} className='form-control'>
                                                <option value="0">تمامی واحدها</option>
                                                <option value="1">واحدهای پر</option>
                                                <option value="2">واحدهای خالی</option>
                                                {/*<option value="3">واحدهای انتخابی</option>*/}
                                                {/*<option value="4">گروه انتخابی</option>*/}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="form-label">گروه انتخابی</label><span className="red">*</span>
                                            <SelectAsync
                                                defaultValue={this.state.data.record.buildingUnitCategoryId != this.getDefaultGuid() ? [{ value: this.state.data.record.buildingUnitCategoryId, label: this.state.data.record.buildingUnitCategoryTitle }] : null}
                                                isMulti={false}
                                                isClearable={true}
                                                placeholder="انتخاب گروه"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadBuildingUnitCategoriesOptions(inputValue, callback)}
                                                onChange={e => this.setBuildingUnitCategory(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">شماره پیگیری</label>
                                            <input type="text" defaultValue={this.state.data.record.followNumber} onChange={e => this.state.data.record.followNumber = e.target.value} className='form-control' />
                                        </div>
                                    </div>
                                </div>
                                {this.state.type === 2 && <label className="form-label">آیتم های محاسباتی</label>}
                                {this.state.type === 2 && <table className="table table-ulogs invoceEntryTable">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ "width": "120px" }} className="text-center">مبلغ واحد</th>
                                            <th className="text-center">عامل افزاینده</th>
                                            <th style={{ "width": "60px" }} className="text-center">عملیات</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.record.formulas.map(child =>
                                            <tr key={child.id}>
                                                <td>
                                                    <NumberFormat value={child.price} onChange={e => this.setFormula(child.id, 'price', this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control' style={{ "width": "100%" }} />
                                                </td>
                                                <td>
                                                    <select defaultValue={child.multiplierType} onChange={e => this.setFormula(child.id, 'multiplierType', parseInt(e.target.value))} className='form-control' style={{ "width": "100%" }}>
                                                        <option value="0">هر واحد به اندازه مبلغ پایه</option>
                                                        <option value="1">ضربدر تعداد نفرات</option>
                                                        <option value="2">ضربدر متراژ</option>
                                                        <option value="3">ضربدر تعداد پارکینگ</option>
                                                        <option value="4">ضربدر شماره طبقه</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <a className="hand btn btn-danger" onClick={e => this.removeFormula(child.id)}>حذف</a>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                }
                                {this.state.type === 2 && <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <a className="hand btn btn-primary" onClick={e => this.addNewFormual()}>افزودن آیتم محاسباتی جدید</a>
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-sm-12">
                                        <label className="form-label">واحدهای انتخاب شده</label>
                                        <div className="form-control-wrap">
                                            <table className="table table-ulogs invoceEntryTable">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th className="text-center">عنوان واحد</th>
                                                        <th style={{ "width": "120px" }} className="text-center">مبلغ کل</th>
                                                        <th style={{ "width": "120px" }} className="text-center">تخفیف</th>
                                                        <th style={{ "width": "120px" }} className="text-center">مبلغ قابل پرداخت</th>
                                                    </tr>
                                                </thead>
                                                <tbody key={this.state.gridVersion}>
                                                    {this.state.data.record.units.map(record =>
                                                        <tr key={record.unitId}>
                                                            <td><input style={{ "width": "100%" }} className="form-control" type="text" defaultValue={this.getUnitTitle(record.unitId)} disabled={true} /></td>
                                                            <td><input style={{ "width": "120px" }} className="form-control" type="text" defaultValue={record.price} disabled={true} thousandSeparator={true} /></td>
                                                            <td><input style={{ "width": "120px" }} className="form-control" type="text" defaultValue={record.discount} onChange={e => this.setUnitDiscount(record.unitId, parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} /></td>
                                                            <td key={this.state.totalVersion}><input style={{ "width": "120px" }} className="form-control" type="text" defaultValue={record.price - record.discount} disabled={true} thousandSeparator={true} /></td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}